import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { allQueryParams } from '@aston/foundation';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { currentTenantId } from './app/authentication-module/functions/utils.functions';

// check/store the tenant id before any redirection
console.log(`[init] app as T${currentTenantId()}`);

// global debugging flags
const qp = allQueryParams()
const noprod = !environment.production;
window['__aston_debug_inactivity'] = qp.aston_debug_inactivity;
window['__aston_force_inactivity'] = qp.aston_force_inactivity;
window['__aston_debug_auth'] = noprod || qp.aston_debug_auth;
window['__aston_debug_ws'] = noprod || qp.aston_debug_ws;
window['__aston_debug_start'] = qp.aston_debug_start;
window['__aston_debug_notes'] = qp.aston_debug_notes;
window['__aston_bootstrap_time'] = new Date().getMilliseconds();

if (environment.production) {
	enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
	.catch(err => console.error(err));
